import { render, staticRenderFns } from "./couponBatchList.vue?vue&type=template&id=89c6a20e&scoped=true"
import script from "./couponBatchList.vue?vue&type=script&lang=js"
export * from "./couponBatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c6a20e",
  null
  
)

export default component.exports